module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/profile/profile-m-81d84f494ca81d8c3477f243831ad9a4.png";